import React from 'react'
import classes from './TeamActivityAccordion.css'
import _ from 'lodash'
import moment from 'moment'
import AnimateHeight from 'react-animate-height'
import CheckmarkIcon from 'static/images/success.svg'
import RxIcon from 'static/images/rx.svg'
import DashboardPatientRow from '../DashboardPatientRow'
import FormattedDate from '../../components/FormattedDate'
import { getDateFormat } from '../../constants'

export const TeamActivityAccordion = props => {
  const {
    connections,
    connectionType,
    doToggleAccordion,
    expanded,
    navigateToPatient,
    templates,
    me,
  } = props

  const dateFormat = getDateFormat(me)

  const connectionMsg = {
    expired: 'patients have completed their connection period',
    expired1: 'patient has completed their connection period',
    connected: 'patients have connected',
    connected1: 'patient has connected',
    pending: 'patients were sent an order but have not connected',
    pending1: 'patient was sent an order but has not connected',
    canceled: 'patients have canceled their order',
    canceled1: 'patient has canceled their order',
  }

  const getConnectionMsg = (type, count) => {
    const newType = count === 1 ? `${type}1` : type
    return connectionMsg[newType]
  }

  const connectionIcon = {
    expired: CheckmarkIcon,
    connected: RxIcon,
    pending: RxIcon,
    canceled: RxIcon,
  }

  const getIcon = conType => {
    const Icon = connectionIcon[conType]
    return (
      <Icon className={classes[conType]} />
    )
  }

  const groupedConnections = _.groupBy(connections, c => moment(c.activityDate).startOf('day').format())

  const toggleText = expanded ? 'Hide' : 'Show'
  const getToggleBtnClass = () => (connections.length > 0 ? 'showBtn' : 'showBtnDisabled')

  const renderGroupedTiles = cons => cons.map((connection, i) => (
    <DashboardPatientRow
      key={`${connection.activityDate}_${connection.participant.id}`}
      navigateToPatient={navigateToPatient}
      participant={connection.participant}
    />
  ))

  const renderGroups = () => {
    const dates = Object.keys(groupedConnections).sort().reverse()
    const content = []
    dates.forEach((date, i) => {
      content.push((
        <div key={date.valueOf()}>
          <div className={classes.dateGroup}>
            <FormattedDate
              date={date}
              fmt={dateFormat}
              todayFmt={dateFormat}
              yesterdayFmt={dateFormat}
              me={me}
            />
          </div>
          {renderGroupedTiles(groupedConnections[date])}
        </div>
      ))
    })
    return content
  }

  return (
    <div className={classes.teamActivityAccordion}>
      <div className={classes.controlRow}>
        <span className={classes.icon}>
          {getIcon(connectionType)}
        </span>

        <span className={classes.heading}>
          <span className={classes.count} id={`activity${_.capitalize(connectionType)}Count`}>
            {connections.length}&nbsp;
          </span>
          {getConnectionMsg(connectionType, connections.length)}
        </span>

        <span
          data-action={`toggle-team-activity-${connectionType}`}
          className={classes[getToggleBtnClass()]}
          onClick={e => doToggleAccordion(connectionType)}
        >
          {toggleText}
        </span>
      </div>

      <AnimateHeight
        duration={250}
        easing="ease-in-out"
        height={expanded ? 'auto' : 0}
      >
        <div className={classes.tilesWrapper}>
          {renderGroups()}
        </div>
      </AnimateHeight>
    </div>
  )
}

export default TeamActivityAccordion



// WEBPACK FOOTER //
// ./src/legacy/components/TeamActivityAccordion/TeamActivityAccordion.jsx